import {
    getJSON,
    paymentDelJSON,
    paymentGetJSON,
    paymentPostJSON,
    paymentPutJSON,
    postJSON,
    reportGetJSON
} from "./requests";

export const findPartnerLoginInfo = async (data) => await paymentPostJSON('/payment/partners/login', data);
export const findPartnerBilling = async () => await getJSON('/partner/billing-details');
export const findPartnerDetails = async () => await paymentGetJSON('/payment/partners/details');
export const findPartnerAccounts = async () => await getJSON('/partner/accounts');
export const updatePartnerPassword = async (data) => await paymentPutJSON('/payment/partners/details/update', data);
export const findPartnerPayments = async () => await paymentGetJSON('/payment/partners/users/charges');
export const findPartnerPaymentsCard = async () => await paymentGetJSON('/payment/partners/users');
export const addPartnerPaymentCard = async (data) => await paymentPutJSON('/payment/partners/users/card', data);
export const createPartnerPaymentUser = async () => await paymentPostJSON('/payment/partners/users');
export const updatePartnerPaymentCard = async (data) => await paymentPutJSON('/payment/partners/users/card', data);
export const removePartnerPaymentCard = async () => await paymentDelJSON('/payment/partners/users/card');
export const updatePartnerBankInfo = async (data) => await paymentPostJSON('/payment/partners/stripe/connect', data);
export const addNewPartner = async (data) => await paymentPostJSON('/payment/partners/add', data);
export const findReferralLink = async () => await paymentGetJSON('/payment/partners/invitation-link');
export const getPayoutsInfo = async () => await paymentGetJSON('/payment/partners/payouts/v2');
export const findThirdPartyWeeklyBillingDetails = async () => await paymentGetJSON('/payment/third-party/weekly-billing');
export const findPartnerCompanyPlanUpgrade = async (data) => await paymentPutJSON('/payment/partner/customer/plan', data);
export const findStoreExtendedReport = async (id, date) => await reportGetJSON('/partner/company-specific-orders?companyId=' + id + "&date=" + date);
export const findMagicLink = async (data) => await postJSON('/partner/access/account', data);

export const fetchACHBankInfo = async () => await paymentGetJSON('/payment/partners/ach');
export const initACH = async () =>  await paymentPostJSON("payment/partners/init/ach", {});
export const findPayoutBankInfo = async () => await paymentGetJSON("payment/partners/stripe/connect");

export const initPaypalConnect = async () => await paymentPostJSON('/paypal/partner/account/connect');
export const findPaypalInfo = async () => await paymentGetJSON('/paypal/partner/account');
export const findPaypalIdentity = async () => await paymentGetJSON('/paypal/partner/identity');
export const initPaypalIdentityConnect = async (data) => await paymentPostJSON('/paypal/partner/identity/connect', data);
export const deletePaypalIdentity = async () => await paymentDelJSON('/paypal/partner/identity');

export const findLastMonthBilling = async () => await paymentGetJSON("/payment/partners/last-month-billing");
export const clearPartnerDues = async (id) => await paymentPutJSON(`/admin/charge/partners/clear/${id}`)

export const createOtp = async (data) => await paymentPostJSON("/payment/partners/phone/send-otp", data);
export const verifyOtp = async (data) => await paymentPostJSON("/payment/partners/phone/verify-otp", data);
export const createPartnerV2 = async (data) => await paymentPostJSON("/payment/partners/add/v2", data);
